import { DestinationStandardMapping } from "../types";

export const podsightsStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [
    {
      eventName: "addtocart",
      description: "When a product added to the shopping cart.",
      propertiesArr: [],
    },
    {
      eventName: "checkout",
      description: "When a transaction or order is started.",
      propertiesArr: [],
    },
    {
      eventName: "lead",
      description: "When a user signs up.",
      propertiesArr: [],
    },
    {
      eventName: "product",
      description: "When a product is viewed.",
      propertiesArr: [],
    },
    {
      eventName: "purchase",
      description: "When an order is completed.",
      propertiesArr: [],
    },
  ],
};

export const getPodsightsStandardMapping = async () => {
  return podsightsStandardMapping;
};
